import * as z from "zod";

export const getUserFeatureFlag = {
  name: "getUserFeatureFlag" as const,
  input: z.object({ key: z.string() }),
  output: z.object({ enabled: z.boolean() }),
};
